"use client";

import { ReactNode, useRef, useState } from "react";
import WisdomModal, { getRandomWisdomQuote } from "./WisdomModal";

const DOUBLE_CLICK_WINDOW_MS = 600;

interface WisdomTriggerProps {
  children: ReactNode;
  className?: string;
}

export default function WisdomTrigger({ children, className }: WisdomTriggerProps) {
  const [open, setOpen] = useState(false);
  const [quote, setQuote] = useState("");
  const clickCount = useRef(0);
  const lastClickTime = useRef(0);

  const handleClick = () => {
    const now = Date.now();
    if (clickCount.current === 1 && now - lastClickTime.current < DOUBLE_CLICK_WINDOW_MS) {
      clickCount.current = 0;
      setQuote(getRandomWisdomQuote());
      setOpen(true);
    } else {
      clickCount.current = 1;
    }
    lastClickTime.current = now;
  };

  return (
    <>
      <div className={className} onClick={handleClick}>
        {children}
      </div>
      <WisdomModal open={open} quote={quote} onClose={() => setOpen(false)} />
    </>
  );
}
